function FAQArchive(el) {
    this.el = el;
    this.searchInputEl = this.el.querySelector('.jsSearchInput');
    this.sectionEls = this.el.querySelectorAll('.jsSection');
    this.questionEls = this.el.querySelectorAll('.jsQuestion');
    this.sectionTriggerWrapperEl = this.el.querySelector('.jsSectionTriggerWrapper');

    // Add event listeners
    this.searchInputEl.addEventListener('keyup', _ => this.filterResults());
    window.addEventListener('scroll', _ => this.setActiveSection());

    this.sectionTriggerWrapperEl.addEventListener('click', e => {
        if (e.target.classList.contains('jsSectionTrigger')) {
            const section = this.el.querySelector('.jsSection[data-section-slug="' + e.target.dataset.sectionSlug + '"]');
            vanillaSmoothie.scrollTo(section.getBoundingClientRect().y + window.scrollY - 50, { duration: 500, easing: 'easeInOutQuad' });
        }
    });

    this.setActiveSection();
}

FAQArchive.prototype.filterResults = function() {
    if (this.searchInputEl.value === '') {
        for (let i = 0; i < this.questionEls.length; i++) {
            this.questionEls[i].classList.remove('hidden');
        }
    }
    else {
        for (let i = 0; i < this.questionEls.length; i++) {
            if (this.questionEls[i].dataset.index.toLowerCase().indexOf(this.searchInputEl.value.toLowerCase) > -1) this.questionEls[i].classList.remove('hidden');
            else this.questionEls[i].classList.add('hidden');
        }
    }
};

FAQArchive.prototype.setActiveSection = function() {
    const triggerPoint = window.scrollY + (window.innerHeight * 0.2);

    for (let i = 0; i < this.sectionEls.length; i++) {
        const section = this.sectionEls[i];
        const bounds = section.getBoundingClientRect();
        const sectionTrigger = this.el.querySelector('.jsSectionTrigger[data-section-slug="' + section.dataset.sectionSlug + '"]');

        if (bounds.y + window.scrollY <= triggerPoint && bounds.y + window.scrollY + bounds.height >= triggerPoint) sectionTrigger.classList.add('active');
        else sectionTrigger.classList.remove('active');
    }
};

(function() {
    const faqArchiveEl = document.querySelector('.jsFaqArchive');
    if (faqArchiveEl) new FAQArchive(faqArchiveEl);
})();
